import { Route, Switch } from "react-router-dom";
import MessagingBannerNonNavigationCtAsPage from "@faire/prototype-playground/workspace/jh/messaging-banner-non-nav-ctas";
import TestMobileHomepagePage from "@faire/prototype-playground/workspace/jh/test-mobile-homepage";

export function JasonHuRoutes() {
  return (
    <Switch>
      <Route path="/jh/messaging-banner-non-nav-ctas" component={MessagingBannerNonNavigationCtAsPage} />
      <Route path="/jh/test-mobile-homepage" component={TestMobileHomepagePage} />
    </Switch>
  );
}

export const slug = "jh";
